export const INIT = 'init' // 活動尚未開始
export const STARTED = 'started' // 活動進行中
export const DONE = 'done' // 活動結束
